function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFD54F",
  d: "M40.463 7.538c-5.2-5.199-12.813-1.482-17.154 2.86-.323.323-.627.674-.921 1.036l14.179 14.179c.362-.294.713-.598 1.036-.921 4.341-4.34 8.057-11.955 2.86-17.154z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFECB3",
  d: "M25.252 14.353c.318-.437.659-.841 1.017-1.198 2.438-2.437 9.372-7.578 12.764-4.188-4.523-4.521-11.261-.173-14.193 2.759a11.84 11.84 0 00-1.024 1.19l1.436 1.437z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9E9D24",
  d: "M24.728 38.998l13.59-13.591L22.594 9.684 9.003 23.272a2.023 2.023 0 01-2.859 2.859L4 28.276 19.723 44l2.146-2.144a2.02 2.02 0 112.859-2.858z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#827717",
  d: "M21.868 38.998a2.023 2.023 0 012.859 0L9.003 23.272a2.023 2.023 0 01-2.859 2.859l15.725 15.725a2.02 2.02 0 01-.001-2.858z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C0CA33",
  d: "M24.738 11.826l1.43 1.43-13.591 13.59-1.43-1.43zM8.288 28.276l1.43 1.43-2.144 2.144-1.43-1.43z"
});

var Svg16Ammo = function Svg16Ammo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg16Ammo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/16-ammo.0b1a31d9.svg";
export { ForwardRef as ReactComponent };